import { Bridge } from '@_shared/config';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { InformationPopup } from '@_shared/ui/Popup';

export function AlertAccessPopup() {
	const { popLayer } = useUILayerStore();

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<InformationPopup.TextContainer>
				<InformationPopup.Title>
					잠깐, 이대로면 저장한 콘텐츠의 알림을 받아볼 수 없어요!
				</InformationPopup.Title>
				<InformationPopup.SubText>
					알림을 켜면 공유한 콘텐츠의 저장이
					<br />
					완료되었는지 확인할 수 있어요 :)
				</InformationPopup.SubText>
				<InformationPopup.Warning>
					시스템 설정 &gt; 딸깍 &gt; 알림 허용
				</InformationPopup.Warning>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					취소
				</InformationPopup.Button>
				<InformationPopup.Button
					type="confirm"
					onClick={() => {
						new Bridge().alertAccess();
					}}
				>
					설정
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
